module.exports = __webpack_public_path__ + "static/media/training_for_gains.2204d987.png";